import { Row } from "antd";
import TenantList from "./TenantList";
import { useTenants } from "../../hooks/useTenants";
import TenantFlow from "./TenantFlow";
import { useTenantTopics } from "../../hooks/useTenantTopics";
import { useTenantBranches } from "../../hooks/useTenantBranches";
import { useChats } from "../../hooks/useChats";
import ChatView from "./ChatView";
import { StyledChats } from "./styles";

const Chats = () => {
  useTenants(true);
  useTenantTopics({ fetch: true });
  useTenantBranches(true);
  const { selectedChatId, selectedTenantId } = useChats(true);
  return (
    <StyledChats className={"w-100 h-100 flex"}>
      <Row
        style={{ flex: 1, width: "100%" }}
        className={`${
          selectedChatId
            ? "chat-view-open"
            : selectedTenantId
              ? "tenant-flow-open"
              : "tenant-list-open"
        }`}
      >
        <TenantList />
        <TenantFlow />
        <ChatView />
      </Row>
    </StyledChats>
  );
};

export default Chats;
